import React, { Component } from 'react'
import isTouchDeviceFunction from 'is-touch-device'

import TwitterIcon from '@material-ui/icons/Twitter';
import GitHubIcon from '@material-ui/icons/GitHub';
import PublicIcon from '@material-ui/icons/Public';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

import SideBarButton from './SideBarButton';

import './HallOfFame.css'
import placeholderImg from '../img/ball.png';

const isTouchDevice = isTouchDeviceFunction();


export default class HallOfFame extends Component {

    constructor(props){
        super(props);

        this.state = {
            moveSpeed: 1,
            moveDirection: 0,
            moveUpdateFrequ: 120, //120
            mouseOver: false,
            mouseOverIcon: false,
            mapHof: true,
            timerUpdateFrequ: 1000,
            nextHof: "--:--:--",
            hofBlink: false,
            newHof: false
        }

        this.listRef = React.createRef()
        this.scrollingHandle = false
        this.animateTimerHandle = setInterval(this._animateTimer, this.state.timerUpdateFrequ)
    }

    _setAnimationInterval = (animate) => {
        clearInterval(this.scrollingHandle) // just to be sure, always cancel first
        if(animate){
            this.scrollingHandle = setInterval(this._animateScroll, this.state.moveUpdateFrequ)
        }
    }

    _animateScroll = () => {
        if(this.state.mouseOver){
            return false
        }

        const listRef = this.listRef.current
        if(listRef.scrollTop === 0){
            this.setState({
                moveDirection: 1
            })
        }
        if(listRef.scrollHeight - listRef.scrollTop === listRef.clientHeight){
            this.setState({
                moveDirection: -1
            })
        }

        const nextPos = listRef.scrollTop + this.state.moveDirection*this.state.moveSpeed
        //listRef.scrollTo(0,nextPos) // not working on edge (check: https://stackoverflow.com/questions/6736849/scrolltop-not-working-in-ie/6736886)
        listRef.scrollTop = nextPos
    }

    _handleMouseOver = (e) => {
        e.preventDefault()
        if(e.type === "mouseenter"){
            this.setState({
                mouseOver: true
            })
        }else if(e.type === "mouseleave"){
            this.setState({
                mouseOver: false
            })
        }
    }

    _toggleHofInfo = (e, index) => {
        e.preventDefault()
        if(e.type === "mouseover" || e.type === "click"){
            const boundingBox = e.target.getBoundingClientRect();
            this.setState({
                mouseOverIcon: {
                    left: boundingBox.left,
                    top: boundingBox.top,
                    index
                },
                mouseOver: true // for touch devices (that don't trigger the mouseEnter event)
            })
        }else if(e.type === "mouseleave"){
            this.setState({
                mouseOverIcon: false
            })
        }
    }

    _untoggleHof = (e) => {
        if(this.state.mouseOverIcon && (!e.target.classList.contains('hof-li') && !e.target.classList.contains('hof-li-icon'))){
            this.setState({
                mouseOverIcon: false,
                mouseOver: false  // for touch devices (that don't trigger the mouseEnter event)
            })
        }
    }

    _mapHof = () => {
        return this.props.hofData.map( (entry, index) => {
            const image = entry.player.image 
                ? <img key="icon" className="hof-li-icon" src={entry.player.image} alt={`${entry.player.name}s Icon`} />
                : <img key="icon" className="hof-li-icon" src={placeholderImg} alt="Placeholder" />
            const text = this.props.fullHof
                ? `${entry.player.name} (${(entry.time/1000).toFixed(1)})`
                : `${(entry.time/1000).toFixed(0)}`
            const content = entry.player.link 
                ? <a key="content" className="hof-li-a" title={`${entry.player.name}s Link`} href={entry.player.link} target="_blank" rel="noopener noreferrer">{text}</a>
                : text
            const newHofClass = this.state.newHof && index === 0 ? "new-hof" : ""

            return <li className={"hof-li "+newHofClass} key={"rank-"+index} onMouseOver={!isTouchDevice ? (e => this._toggleHofInfo(e, index)) : undefined} onMouseLeave={!isTouchDevice ? this._toggleHofInfo : undefined} onClick={isTouchDevice ? (e => this._toggleHofInfo(e, index)) : undefined}>{[image, content]}</li>
        })
    }

    _mountInfoBox = () => {
        if(!this.state.mouseOverIcon){
            return null
        }
        const infoData = this.props.hofData[this.state.mouseOverIcon.index]
        const time = (infoData.time/1000).toFixed(1)
        const name = this.props.fullHof ? "" : infoData.player.name+" | "
        const hour = Math.ceil((infoData.timestamp - Date.now())/1000/60/60)
        let handle = ""
        if(infoData.player.link){
            const extraIcon = isTouchDevice && <OpenInNewIcon key="external-link-icon" fontSize="small" className="external-link-icon"/>
            if(infoData.player.link.includes("https://twitter.com/")){
                const linkText = !isTouchDevice && "@"+infoData.player.link.split("https://twitter.com/")[1]
                handle = [<TwitterIcon key="twitter-icon" fontSize="small"/>, extraIcon, linkText]
            }else if(infoData.player.link.includes("https://github.com/")){
                const linkText = isTouchDevice ? "" : infoData.player.link.split("https://github.com/")[1]
                handle = [<GitHubIcon key="github-icon" fontSize="small" className="github-icon"/>, extraIcon, linkText]
            }else if(infoData.player.link){
                const linkText = isTouchDevice ? "" : infoData.player.link.split("//")[1].split("/")[0] // reduce the url to the domain
                handle = [<PublicIcon key="public-icon" fontSize="small"/>, extraIcon, linkText]
            }
            // wrap the handle into an a tag, mainly for touch devices (disabeling the warning for missing noreferrer, because I want the other page to know where the visitors came from)
            // eslint-disable-next-line
            handle = <a key="handle-link" href={infoData.player.link} target="_blank" rel="noopener" >{handle}</a>
        }

        return [hour + "h | " + time + "s | " + name, handle]
    }

    _formatNumber = (value) => {
        // change negative numbers to 0 and add a leading 0 if necessary
        value = value < 0 ? 0 : value;
        return value < 10 ? "0"+value : value
    }

    _animateTimer = () => {
        if(!this.props.nextHof || typeof this.props.nextHof !== "number"){
            return this.setState({
                nextHof: "--:--:--"
            })
        }

        if(this.props.collapsed === "fullyCollapsed"){
            return
        }

        const diffSecs = (this.props.nextHof - Date.now())/1000
        const seconds = Math.floor(diffSecs%60)
        const minutes = Math.floor((diffSecs/60)%60)
        const hours = Math.floor(diffSecs/60/60)

        this.setState({
            nextHof: this._formatNumber(hours)+":"+this._formatNumber(minutes)+":"+this._formatNumber(seconds),
            hofBlink: diffSecs < 10 && seconds%2
        })
    }

    _animateNewHof = () => {
        
        // get a ref to the hof list and scroll it to the top
        const listRef = this.listRef.current
        listRef.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
        
        // pause the hof list animation for 5 seconds
        this._setAnimationInterval(false)
        setTimeout( () => this._setAnimationInterval(true), 5000)

        // set the newHof flag and remove it after 5 seconds
        this.setState({
            newHof: true,
            mouseOverIcon: false // in case the hof info was open
        })
        setTimeout( () => this.setState({newHof: false}), 5000)
    }

    componentDidMount(){
        this._setAnimationInterval(this.props.animated)
        document.addEventListener('click', this._untoggleHof)
    }

    componentWillUnmount(){
        this._setAnimationInterval(false)
        document.removeEventListener("click", this._untoggleHof)
    }

    shouldComponentUpdate(nextProps, nextState){
        return this.props.fullHof !== nextProps.fullHof ||
            this.props.hofData !== nextProps.hofData ||
            this.props.hofData[0] !== nextProps.hofData[0] ||
            this.props.collapsed !== nextProps.collapsed || 
            this.props.animated !== nextProps.animated ||
            this.state.mouseOverIcon !== nextState.mouseOverIcon ||
            this.state.mapHof !== nextState.mapHof ||
            this.state.nextHof !== nextState.nextHof ||
            this.state.hofBlink !== nextState.hofBlink ||
            this.state.newHof !== nextState.newHof ||
            this.state.mouseOver !== nextState.mouseOver
    }

    componentDidUpdate(prevProps){
        if(prevProps.collapsed !== this.props.collapsed && this.props.animated){
            const collapsed = this.props.collapsed === "fullyCollapsed" || this.props.collapsed === "partlyCollapsed"
            this._setAnimationInterval(!collapsed)
            if(collapsed){
                setTimeout( () => this.setState({mapHof: false}), 300) // remove the mapping of the hof after a short delay for better performance
            }else{
                this.setState({mapHof: true})
            }
        }
        if(prevProps.animated !== this.props.animated){
            this._setAnimationInterval(this.props.animated)
        }
        if(this.props.hofData[0] !== prevProps.hofData[0] && prevProps.hofData[0]){
            // new hof entry, animate it for a moment and scroll to top of list
            this._animateNewHof()
        }
        if(prevProps.collapsed !== this.props.collapsed){
            // hide the hof info box (this is only relevant on mobile)
            this.setState({
                mouseOverIcon: false
            })
        }
    }

    render(){
        const fullHof = this.props.fullHof
        const boxExtraClass = fullHof ? "full" : "part"
        const fullyCollapsed = this.props.collapsed === "fullyCollapsed"
        const partlyCollapsed = this.props.collapsed === "partlyCollapsed"
        const hofLoaded = this.props.hofData && this.props.hofData.length > 0
        const fullContentHeight = fullyCollapsed 
            ? 0 
            : partlyCollapsed 
                ? 66
                : 191 // hardcoded pixel values as 'auto' can't be translated :/
        const boxHeight = partlyCollapsed ? 0 : 125
        const infoBoxWidthFull = isTouchDevice ? 170 : 300
        const infoBoxWidthPart = isTouchDevice ? 230 : 350
        const infoBoxStyle = this.state.mouseOverIcon 
            ? {width: fullHof ? infoBoxWidthFull : infoBoxWidthPart, top: this.state.mouseOverIcon.top-4, opacity: 1}
            : {width: 0, opacity: 0}
        const blinkClass = this.state.hofBlink ? " blink" : ""

        return (
            <div className={"hof-wrapper"+(fullyCollapsed?" collapsed":"")} style={{height: fullContentHeight}}>
                <SideBarButton 
                    fullText="Hall Of Fame" 
                    smallText="HoF" 
                    handleButtonClick={this.props.toggleHof} 
                    fullButton={fullHof} 
                    collapsed={this.props.collapsed} 
                />
                <div className={"hof-box "+boxExtraClass+(partlyCollapsed?" collapsed":"")} ref={this.listRef} onMouseEnter={!isTouchDevice ? this._handleMouseOver : undefined} onMouseLeave={!isTouchDevice ? this._handleMouseOver : undefined} style={{height: boxHeight}}>
                    <div className="hof-content">
                        {
                            hofLoaded && this.state.mapHof
                            ? <ul className="hof-ul">
                                { this._mapHof() }
                            </ul>
                            : "..."
                        }
                    </div>
                </div>
                <div className={"hof-next-hof-box "+boxExtraClass+blinkClass}>
                    {
                        (fullHof ? "next: " : "")+this.state.nextHof
                    }
                </div>
                <div className={"hof-hover-info-box "+boxExtraClass} style={infoBoxStyle}>{this._mountInfoBox()}</div>
            </div>
        )
    }
}